import { PropsWithChildren } from 'react';

import { ChakraProvider } from '@chakra-ui/react';
import { Provider } from 'react-redux';

import { THEME } from '~/themes/theme';

import { store } from './store/redux-store';
import { Fonts } from './themes/Fonts';

function AppProvider({ children }: PropsWithChildren) {
  return (
    <Provider store={store}>
      <ChakraProvider theme={THEME}>
        <Fonts />
        {children}
      </ChakraProvider>
    </Provider>
  );
}

export default AppProvider;
